/** Textos exibidos na UI durante preparo/início da gravação (sem fila, infra, etc.). */

export const RECORDING_PREPARING_TITLE = 'Preparando gravação…';

export const RECORDING_PREPARING_SUBTITLE =
  'Em instantes a gravação será iniciada automaticamente.';

export const RECORDING_PREPARING_HINT_SLOW =
  'Isso pode levar um pouco mais que o habitual.';

export const RECORDING_PREPARING_HINT_LONG = 'A espera está maior que o normal.';

export const RECORDING_PREPARING_TOAST = RECORDING_PREPARING_TITLE;

export const RECORDING_PREPARING_REMOTE = (actorName: string) =>
  `${actorName} está preparando a gravação…`;

export const RECORDING_PREPARING_BUTTON_TITLE = 'Preparando gravação…';

export const RECORDING_PREPARING_BUTTON_CANCEL =
  'Preparando gravação… (clique para cancelar)';

/** Egress pedido — ainda não há arquivo. Distinto de "gravando". */
export const RECORDING_STARTING_TITLE = 'Iniciando gravação…';

export const RECORDING_STARTING_SUBTITLE =
  'Aguarde a confirmação. O arquivo só começa a ser gravado depois disso.';

export const RECORDING_STARTING_BUTTON_TITLE = 'Iniciando gravação…';

export const RECORDING_STARTING_BUTTON_STOP =
  'Iniciando gravação… (clique para interromper)';

export const RECORDING_RECOVER_BUTTON_LABEL = 'Buscar gravação no projeto';

export const RECORDING_RECOVER_OK_MESSAGE =
  'Gravação encontrada e vinculada ao projeto.';

export const RECORDING_RECOVER_MISS_MESSAGE =
  'Não encontramos um arquivo desta reunião no armazenamento.';

export const RECORDING_RECOVER_BUSY_MESSAGE =
  'Há uma gravação em andamento. Encerre-a antes de buscar no armazenamento.';

export const RECORDING_RECOVER_QUALITY_MESSAGE =
  'Encontramos um arquivo, mas ele não atende ao critério mínimo para publicar no projeto.';

/** Resposta da API / record/start — não expor fila ao usuário. */
export const RECORDING_API_PREPARING_MESSAGE = RECORDING_PREPARING_SUBTITLE;

/** Falha ao iniciar (prepare/queue/egress start). */
export const RECORDING_START_FAILED_MESSAGE =
  'Não foi possível iniciar a gravação. Tente novamente em instantes.';

/** Popup persistente — a borda amarela some e este aviso fica até o clique. */
export const RECORDING_START_FAILED_TITLE = 'A gravação não começou';

export const RECORDING_START_FAILED_BODY =
  'Não foi possível iniciar a gravação. Tente novamente.';

export const RECORDING_START_FAILED_DISMISS = 'Entendi';

/** Job criado mas Chrome nunca capturou (STARTING / Start signal not received). */
export const RECORDING_NEVER_STARTED_USER_MESSAGE =
  'A gravação não chegou a começar. Tente de novo.';

/**
 * Egress interrompido durante reunião (pod morreu, OOM, webhook egress_failed).
 * Distinto de falha no início — o usuário já estava gravando.
 */
export const RECORDING_INTERRUPTED_USER_MESSAGE =
  'A gravação foi interrompida inesperadamente. Verifique se o vídeo apareceu no projeto; caso contrário, inicie uma nova gravação.';

/** Servidor vai re-enfileirar gravação após falha (auto-restart). */
export const RECORDING_AUTO_RESTART_MESSAGE =
  'Gravação interrompida — reiniciando automaticamente.';

export const RECORDING_RETRY_BUTTON_LABEL = 'Tentar gravar novamente';

export const RECORDING_AUTO_RESTART_OPT_OUT_LABEL = 'Não reiniciar automaticamente';

export const RECORDING_LIVENESS_RECONNECTING_MESSAGE =
  'Detectamos instabilidade na gravação. Estamos reconectando…';

export const RECORDING_LIVENESS_FAILED_USER_MESSAGE =
  'Perdemos a conexão com a gravação e não conseguimos restabelecê-la automaticamente. ' +
  'O trecho já capturado foi preservado quando possível. Inicie uma nova gravação se a reunião continuar.';

/** Gravação encerrou com sucesso, mas a reunião segue aberta (nova sessão exige novo clique). */
export const RECORDING_SAVED_ROOM_CONTINUES_MESSAGE =
  'Gravação finalizada e salva. A reunião continua — inicie uma nova gravação se precisar.';

/**
 * API LiveKit temporariamente indisponível (ex.: "no response from servers").
 * A gravação no pod egress pode continuar — não tratar como perda fatal.
 */
export const RECORDING_SERVER_BUSY_CONTINUES_MESSAGE =
  'Servidor ocupado momentaneamente — a gravação continua. Aguarde alguns instantes.';

/** Sala ficou sem participantes humanos — gravação encerrada de propósito. */
export const RECORDING_ROOM_EMPTY_ENDED_MESSAGE =
  'Sala vazia — gravação encerrada e salva no projeto quando disponível.';
